import { render, staticRenderFns } from "./channel_icon_edit.vue?vue&type=template&id=75d825c8"
import script from "./channel_icon_edit.vue?vue&type=script&lang=js"
export * from "./channel_icon_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports